import "./index.scss";

import { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { segmentTrack } from "util/segment";
import { EVENT } from "constants/analytics";
import { Heading } from "common/core/typography";

import media from "./constants";

class TrustedByBanner extends PureComponent {
  trustedItemClicked(event, info) {
    const analyticsData = {
      clickedLink: info.url,
      clickedItem: info.title,
    };

    event.preventDefault();
    segmentTrack(EVENT.TRUSTED_ITEM_CLICKED, analyticsData, {}, () => {
      window.open(info.url, "_blank");
    });
  }

  render() {
    const { items } = this.props;

    return (
      <div className={classnames("TrustedByBanner", this.props.className)}>
        <Heading level="h2" textStyle="allCapsLabelSmall" textColor="subtle">
          <FormattedMessage
            id="f2d2bc69-fbe8-4c97-86f8-4177abe68505"
            description="title"
            defaultMessage="Featured In"
          />
        </Heading>
        <ul>
          {items.map((i) => {
            const info = media[i];
            if (!info) {
              throw new Error(`Unknown featured media ${i}`);
            }
            let trustedItem = <img alt={`${info.title}`} src={info.img} />;
            if (this.props.allowLinks) {
              trustedItem = (
                <a
                  href={info.url}
                  target="_blank"
                  rel="noreferrer noopener"
                  onClick={(e) => this.trustedItemClicked(e, info)}
                >
                  {trustedItem}
                </a>
              );
            }
            return <li key={i}>{trustedItem}</li>;
          })}
        </ul>
      </div>
    );
  }
}

TrustedByBanner.propTypes = {
  items: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(media))),
  allowLinks: PropTypes.bool,
  className: PropTypes.string,
};

TrustedByBanner.defaultProps = {
  items: ["WP", "NPR", "WSJ", "FORTUNE", "INC"],
  allowLinks: true,
};

export default TrustedByBanner;
